import React, { useEffect, useState } from "react";
import svg89 from "../../assets/svg/svg89.svg";
import svg90 from "../../assets/svg/svg90.svg";
import svg91 from "../../assets/svg/svg91.svg";
import { useNavigate } from "react-router-dom";
import { setActiveObj } from "../../features/folder/folderSlice";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "antd";
import EmtyCard from "../../components/EmtyCard";
import { dateForHumans, numberWithCommas } from "../../utils";
import { fetchData } from "../../features/auth/authSlice";
import CardLoading from "../../components/CardLoading";

function CareerCard() {
  const dispatch = useDispatch();
  const url = "api/v1/jobs/getAll";
  const { loading, data, count } = useSelector((state) => ({
    loading: state?.auth?.loading,
    data: state?.auth?.data?.[url] || [],
    count: state?.auth?.count?.[url] || 0,
  }));

  const navigate = useNavigate();
  const handleViewCard = async (item) => {
    await dispatch(setActiveObj({ key: "job", data: item }));
    await handleViewCount(item?.jobId);
    await navigate("/recruitment/career-view-list");
  };

  async function handleViewCount(jobId) { 
    await dispatch(
      fetchData({
        url: `api/v1/jobs/viewCount?jobId=${jobId}`,
        limit: null,
        start: 0,
      })
    );
  }
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        statuses: ["PUBLISH"],
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);
  if (loading) return <CardLoading />;
  return (
    <div className="lg:px-[22.5rem] px-3 font-dmSans">
      <div className="mt-[2.25rem] text-[#000] text-[2rem] font-[500] font-dmSans">
        Ndovu HR Career Opportunities
      </div>

      {loading ? (
        <CardLoading />
      ) : (
        <>
          {data && data?.length ? (
            data?.map((item) => (
              <div
                className={`bg-white rounded-lg p-6 cursor-pointer mt-[1.5rem] mb-[1rem] 
                  hover:border hover:border-[#FDB505] active:border active:border-[#FDB505] transition-all duration-200`}
                onClick={() => handleViewCard(item)}
              >
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                  <div className="flex-1">
                    <h3 className="text-[#3B3B3B] font-[500] text-[1.125rem]">
                      {item?.jobTitle}
                    </h3>
                    <p className="text-[#626262] text-[1rem] font-[400]">
                      {item?.company}
                    </p>

                    <div className="flex items-center space-x-4 text-[#7C7C7C] text-[.75rem] font-[400] mt-[1rem]">
                      <div className="flex items-center space-x-1">
                        <img src={svg89} alt="svg89" />
                        <span>{item?.jobCity}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <img src={svg90} alt="svg90" />
                        <span>{item?.jobViewCount ?? 0} Views</span>
                      </div>
                    </div>

                    <div className="flex items-center space-x-4 text-[#7C7C7C] text-[.75rem] font-[400] mt-2">
                      <span>{dateForHumans(item?.jobAdvertStartDate)}</span>

                      <div className="flex items-center gap-[.5rem]">
                        <img src={svg91} alt="svg91" />
                        <span>{item?.jobWorkType}</span>
                      </div>

                      <div className="flex items-center gap-[.5rem]">
                        <img src={svg91} alt="svg91" />
                        <span>{item?.jobApplicantCount} Applications</span>
                      </div>
                    </div>
                  </div>

                  <div className="text-left">
                    <div className="text-[#626262] text-[.75rem] font-[400]">
                      Closing
                    </div>
                    <div className="text-[#626262] text-[1rem] font-[400]">
                      {dateForHumans(item?.jobAdvertEndDate)}
                    </div>
                    <div>
                      {!item?.jobSalaryConfidentiality && (
                        <>
                          {" "}
                          <span className="text-[#16A34A] text-[1rem] font-[600]">
                            {item?.jobCurrency}{" "}
                            {numberWithCommas(item?.jobGrossPay)}
                          </span>
                          <span className="text-[#7C7C7C] text-[.75rem] font-[400]">
                            /{item?.jobPayFrequency}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="mt-[3.5rem]">
              <EmtyCard />
            </div>
          )}
        </>
      )}

      <div className="flex justify-end my-4">
        <Pagination
          current={pageIndex + 1}
          total={count}
          pageSize={pageSize}
          onChange={(page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          }}
          showSizeChanger={false}
          hideOnSinglePage={true}
        />
      </div>
    </div>
  );
}

export default CareerCard;
